
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartPlainBoundariesIec as ObiChartPlainBoundariesIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-plain-boundaries-iec.js';
 
 
 

 
 export const ObiChartPlainBoundariesIec = createComponent({
   react: React,
   tagName: 'obi-chart-plain-boundaries-iec',
   elementClass: ObiChartPlainBoundariesIecElement,
   events: {
     
   }
  });
 
 